import type { Block, Inline } from '@contentful/rich-text-types';
import type { Quote } from '../quote/quote.types';

export const toQuoteProps = (node: Block | Inline): Quote | undefined => {
  const fields = node?.data?.target?.fields;

  const additionalInfo = fields.additionalInfo;
  const background = fields.background;
  const image = fields.image;
  const quote = fields.quote;
  const quoteTextWeightBold = fields.quoteTextWeightBold;
  const signature = fields.signature;
  const theme = fields.theme;
  const variant = fields.variant;

  if (quote && signature) {
    return {
      additionalInfo,
      background,
      image,
      quote,
      quoteTextWeightBold,
      signature,
      theme,
      variant,
    };
  }

  return undefined;
};
